import { DealStage } from '../deal-stage.enum';
import '@angular/localize/init';

export enum GetDealsQueryExportStatus {
  NoFiltering = 'NoFiltering',
  OnlyExported = 'OnlyExported',
  OnlyNotExported = 'OnlyNotExported',
  Both = 'Both',
}

const EXPORT_STATUS_LABELS = {
  [GetDealsQueryExportStatus.NoFiltering]: $localize`:@@exportStatus.noFiltering:No Filtering`,
  [GetDealsQueryExportStatus.OnlyExported]: $localize`:@@exportStatus.onlyExported:Yes`,
  [GetDealsQueryExportStatus.OnlyNotExported]: $localize`:@@exportStatus.onlyNotExported:No`,
  [GetDealsQueryExportStatus.Both]: $localize`:@@exportStatus.both:Both`,
};
/**
 * Returns a label for the export status
 * @param exportStatus The export status
 * @returns The label for the export status
 */
export function getLabelForExportStatus(exportStatus: GetDealsQueryExportStatus): string {
  return EXPORT_STATUS_LABELS[exportStatus] || 'Unknown';
}

export interface GetDealsQuery {
  searchTerm?: string;

  limitToProjectCampaignIds?: string[];

  limitToDealStages?: DealStage[];

  exportStatus: string;

  pageAfter?: string;

  pageSize: number;
}
